var map = {
	"./1.png": 9765,
	"./10.png": 3752,
	"./11.png": 1394,
	"./12.png": 7969,
	"./2.png": 1548,
	"./3.png": 9612,
	"./4.png": 2022,
	"./5.png": 1737,
	"./6.png": 219,
	"./7.png": 3594,
	"./8.png": 5781,
	"./9.png": 2609
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3599;